import React from 'react'
import TabsContainer from '../../../Components/UiKits/TabBootstrap'

export default function Tabs() {
    return (
        <div className='page-body'>
            <TabsContainer />
        </div>
    )
}
